import React from "react";

const SectionHeader = (props) => {
  return (
    <header
      className={[
        "text-left h-full flex flex-col relative  gap-8",
        props.half && "col-span-1 lg:col-span-2",
        props.noBg ? "" : "lg:bgDotsLeft",
        props.reverse &&
          "lg:row-start-1 lg:row-end-1 lg:col-start-4 lg:text-right lg:bgDotsLeft lg:bgDotsRight",
      ].join(" ")}
    >
      <div
        className={[
          "text-left border-red-400 h-fit pl-2 border-l-2 flex flex-col gap-4 py-1 ",
          props.reverse &&
            "lg:text-right lg:pr-4 lg:border-r-2 lg:pl-0 lg:border-l-0",
        ].join(" ")}
      >
        <h2 className="text-4xl font-serif font-bold text-indigo-900">
          {props.title}
        </h2>
        <p className="line-clamp-2 text-sm text-slate-500">{props.content}</p>
      </div>
      {props.children}
    </header>
  );
};

export default SectionHeader;
